import {getMatchingColor} from '@deskly/shared-ui/config';
import {desklyColors} from '@/shared/mixins/colors';

const whiteLabelStylesId = 'whitelabel-dynamic-styles';

export default {
    methods: {
        /**
         *
         * @param {AccountForm | false} whitelabelInformation
         * @returns void
         */
        whiteLabelCheck(whitelabelInformation = false) {
            if (whitelabelInformation?.favicon) {
                this.setFavIcon(whitelabelInformation.favicon);
            }

            if (whitelabelInformation?.applicationTitle) {
                this.setTitle(whitelabelInformation.applicationTitle);
            }

            if (whitelabelInformation?.customColors) {
                this.setColors(
                    getMatchingColor(whitelabelInformation.primaryColor) ?? desklyColors.primary,
                    getMatchingColor(whitelabelInformation.hoverColor) ?? desklyColors.hover,
                    getMatchingColor(whitelabelInformation.kioskBackgroundColor) ??
                        desklyColors.kioskBackground
                );
                return;
            }

            // No custom colors - clear any existing overrides to show CSS defaults
            this.clearCustomColors();
        },
        setFavIcon(iconUrl) {
            const favicon = document.querySelector('[rel=icon]');
            if (favicon) {
                favicon.href = iconUrl;
            }
        },
        setTitle(title) {
            document.title = title;
        },
        async setColors(primary, hover, kioskBackground) {
            const {generateOverlayColorsAsObject, getTextColor, generatePrimaryPaletteAsCssVars} =
                await import('../../shared/helpers/colorHelper');
            // Generate all color values as an object
            const baseColors = {
                '--color-primary': primary,
                '--color-hover': hover,
                '--color-active': primary,
                '--color-kiosk-mode': kioskBackground || primary,
                '--color-kiosk-mode-inverse': getTextColor(kioskBackground || primary),
            };

            // Generate primary palette (50-950 shades)
            const paletteColors = generatePrimaryPaletteAsCssVars(primary);

            // Generate overlay colors
            const overlayColors = generateOverlayColorsAsObject([
                {label: 'color-primary', hex: primary},
                {label: 'color-hover', hex: hover},
            ]);

            // Combine all colors
            const allColors = {...baseColors, ...paletteColors, ...overlayColors};

            // Create or update style block
            this.injectWhitelabelStyles(allColors);

            // Enable whitelabel theme
            document.documentElement.classList.add('whitelabel-theme');
        },
        injectWhitelabelStyles(colors) {
            // Remove existing whitelabel style block if present
            const existingStyle = document.getElementById(whiteLabelStylesId);
            if (existingStyle) {
                existingStyle.remove();
            }

            // Create CSS string
            const cssVars = Object.entries(colors)
                .map(([key, value]) => `  ${key}: ${value};`)
                .join('\n');

            const cssContent = `.whitelabel-theme {\n${cssVars}\n}`;

            // Inject new style block
            const styleElement = document.createElement('style');
            styleElement.id = whiteLabelStylesId;
            styleElement.textContent = cssContent;
            document.head.appendChild(styleElement);
        },
        clearCustomColors() {
            // Remove the class - CSS defaults from whiteLabelTheme.css cascade back
            document.documentElement.classList.remove('whitelabel-theme');

            // Remove the dynamic style block
            const styleElement = document.getElementById(whiteLabelStylesId);
            if (styleElement) {
                styleElement.remove();
            }
        },
    },
};
